import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { runModeProvider } from 'src/environments/runtime';

import { LayoutsModule } from './layouts/layouts.module';
import { ComponentsModule } from './shared/components/components.module';
import { DeviceHeaderInterceptor } from './shared/interceptors/device-header.interceptor';
import { NetworkActivityInterceptor } from './shared/interceptors/network-activity.interceptor';
import { MaterialModule } from './shared/material.module';
import { SettingsService } from './shared/services/settings/settings.service';
import { StoresModule } from './stores/stores.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AppGuardService, CloudDeploymentGuardService } from './guards';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    ComponentsModule,
    BrowserModule,
    AppRoutingModule,
    MaterialModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    StoresModule,
    LayoutsModule,
    ComponentsModule,
  ],
  providers: [
    SettingsService,
    AppGuardService,
    CloudDeploymentGuardService,
    runModeProvider,
    { provide: 'Window', useValue: window },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NetworkActivityInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DeviceHeaderInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
